/* Hartley & Grey: inline product image zoom (vanilla, no deps).
   Zooms INSIDE the existing image frame - nothing opens over the page.
   Touch: tap = zoom 2.5x at that point, drag = pan, pinch = zoom, tap again / (−) button = reset.
   Mouse: hover magnifies the area under the cursor, back to normal on leave. */
(function () {
  'use strict';
  if (window.HGZoom) return;
  var TAP_SCALE = 2.5, HOVER_SCALE = 2.2, MAX = 4;
  var FRAME_SEL = '.ai-gallery-main, [id^="MediaGallery-"] .product__media-item .product__media';
  var fine = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };

  var css = '' +
    '.hgz-frame{overflow:hidden}' +
    '[id^="MediaGallery-"] .product__media.hgz-frame{touch-action:pan-x pan-y}' +
    '.hgz-frame.hgz-zoomed{touch-action:none!important}' +
    '.hgz-frame .hgz-img{transform-origin:0 0;will-change:transform}' +
    '.hgz-frame .hgz-img.hgz-anim{transition:transform .25s cubic-bezier(.2,.8,.2,1)}' +
    '@media (hover:hover) and (pointer:fine){.hgz-frame{cursor:crosshair}.ai-gallery-main .ai-zoom{display:none!important}}' +
    '.hgz-frame>.hgz-out.hgz-out{position:absolute!important;top:auto!important;left:auto!important;right:12px!important;bottom:12px!important;z-index:4;width:44px!important;height:44px!important;border-radius:50%;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.95);color:#1c1b17;display:none!important;place-items:center;padding:0;margin:0;box-shadow:0 2px 8px rgba(0,0,0,.18);cursor:pointer}' +
    '.hgz-frame.hgz-zoomed>.hgz-out.hgz-out{display:grid!important}.hgz-out svg{width:20px!important;height:20px!important;position:static!important}' +
    '@media (prefers-reduced-motion:reduce){.hgz-frame .hgz-img.hgz-anim{transition:none}}';
  var st = document.createElement('style'); st.id = 'hgz-css'; st.textContent = css; document.head.appendChild(st);
  var ICON_MINUS = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.5"></circle><path d="m16 16 5 5M7.5 10.8h6.6"></path></svg>';

  var Z = new WeakMap(), zoomed = new Set();

  function imgOf(frame) {
    if (frame.classList.contains('ai-gallery-main')) return frame.querySelector('img[data-main-image]');
    if (frame.querySelector('deferred-media, product-model, video, iframe, model-viewer')) return null; /* videos / 3D untouched */
    return frame.querySelector(':scope > img') || frame.querySelector('img');
  }
  function frameOf(el) {
    var f = el && el.closest && el.closest(FRAME_SEL);
    if (!f || f.closest('quick-add-modal, product-modal')) return null;
    return imgOf(f) ? f : null;
  }
  function state(frame) {
    var z = Z.get(frame);
    if (!z) {
      z = { frame: frame, s: 1, tx: 0, ty: 0, mode: null };
      Z.set(frame, z);
      frame.classList.add('hgz-frame');
      frame.addEventListener('touchmove', function (e) { if (z.s > 1.01 || z.mode === 'pinch' || e.touches.length > 1) { if (e.cancelable) e.preventDefault(); } }, { passive: false });
      if (!frame.classList.contains('ai-gallery-main')) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'hgz-out'; b.setAttribute('aria-label', 'Zoom out'); b.innerHTML = ICON_MINUS;
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); reset(z, true); });
        frame.appendChild(b);
      }
    }
    var img = imgOf(frame);
    if (z.img !== img) { if (z.img) clearImg(z.img); z.img = img; z.s = 1; z.tx = z.ty = 0; }
    if (img) img.classList.add('hgz-img');
    return z;
  }
  function scan() { document.querySelectorAll(FRAME_SEL).forEach(function (f) { if (frameOf(f)) state(f); }); }
  function clearImg(img) { img.style.transform = ''; img.classList.remove('hgz-anim'); }

  function measure(z) {
    var f = z.frame, i = z.img;
    z.W = f.clientWidth; z.H = f.clientHeight;
    z.iw = i.offsetWidth; z.ih = i.offsetHeight;
    var fr = f.getBoundingClientRect(), ir = i.getBoundingClientRect();
    /* untransformed offset of the image inside the frame */
    z.ox = ir.left - fr.left - z.tx - f.clientLeft; z.oy = ir.top - fr.top - z.ty - f.clientTop;
    if (z.s === 1) { z.ox = ir.left - fr.left - f.clientLeft; z.oy = ir.top - fr.top - f.clientTop; }
  }
  function clampAxis(t, span, size, o) {
    if (span >= size) return Math.min(-o, Math.max(size - o - span, t));
    return (size - span) / 2 - o;
  }
  function clamp(z) {
    z.tx = clampAxis(z.tx, z.iw * z.s, z.W, z.ox);
    z.ty = clampAxis(z.ty, z.ih * z.s, z.H, z.oy);
    if (z.s === 1) { z.tx = 0; z.ty = 0; }
  }
  function hiRes(z) {
    var i = z.img;
    if (i.dataset.hgzSizes == null) {
      i.dataset.hgzSizes = i.getAttribute('sizes') || '';
      i.setAttribute('sizes', Math.round(z.iw * (z.s > 2.6 ? MAX : 3)) + 'px'); /* browser picks a sharper srcset candidate */
    }
  }
  function lowRes(i) {
    if (i && i.dataset.hgzSizes != null) {
      var v = i.dataset.hgzSizes; delete i.dataset.hgzSizes;
      if (v) i.setAttribute('sizes', v); else i.removeAttribute('sizes');
    }
  }
  function apply(z, anim) {
    var i = z.img; if (!i) return;
    i.classList.toggle('hgz-anim', !!anim);
    i.style.transform = z.s === 1 ? '' : 'translate3d(' + z.tx + 'px,' + z.ty + 'px,0) scale(' + z.s + ')';
    var on = z.s > 1.01;
    z.frame.classList.toggle('hgz-zoomed', on);
    if (on) zoomed.add(z); else zoomed.delete(z);
    var btn = z.frame.querySelector('[data-zoom]');
    if (btn) {
      if (btn._hgzIcon == null) btn._hgzIcon = btn.innerHTML;
      btn.innerHTML = on ? ICON_MINUS : btn._hgzIcon;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in on image');
    }
  }
  function zoomAt(z, ns, fx, fy, anim) {
    measure(z);
    ns = Math.max(1, Math.min(MAX, ns));
    var qx = (fx - z.ox - z.tx) / z.s, qy = (fy - z.oy - z.ty) / z.s;
    z.tx = fx - z.ox - qx * ns; z.ty = fy - z.oy - qy * ns; z.s = ns;
    clamp(z); if (ns > 1.01) hiRes(z); apply(z, anim);
  }
  function reset(z, anim) {
    if (!z || !z.img) return;
    z.s = 1; z.tx = 0; z.ty = 0; z.mode = null; z.hover = false;
    apply(z, anim); lowRes(z.img);
  }
  function resetAll() { Array.from(zoomed).forEach(function (z) { reset(z, false); }); }
  function local(z, e) { var r = z.frame.getBoundingClientRect(); return { x: e.clientX - r.left - z.frame.clientLeft, y: e.clientY - r.top - z.frame.clientTop }; }

  /* ---------- touch / pen: pan + pinch ---------- */
  var pts = new Map(), g = null, lastPointer = 'mouse', suppressClickUntil = 0, multi = false;
  function two() { var a = Array.from(pts.values()); return { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y) || 1, x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }; }
  document.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType;
    if (e.pointerType === 'mouse') return;
    var t = e.target; if (t.closest && t.closest('button, a, input, select, label')) return;
    var f = frameOf(t); if (!f) return;
    var z = state(f); if (!z.img) return;
    if (g && g.z !== z) { pts.clear(); g = null; }
    pts.set(e.pointerId, local(z, e));
    if (pts.size === 1) {
      var p = local(z, e);
      g = { z: z, x0: p.x, y0: p.y, tx0: z.tx, ty0: z.ty, moved: 0 };
      if (z.s > 1.01) { z.mode = 'pan'; try { f.setPointerCapture(e.pointerId); } catch (err) {} }
    } else if (pts.size === 2 && g) {
      var m = two(); multi = true;
      measure(z);
      g.pinch = { d0: m.d, mx: m.x, my: m.y, s0: z.s, tx0: z.tx, ty0: z.ty };
      z.mode = 'pinch'; g.moved = 99;
      pts.forEach(function (_, id) { try { f.setPointerCapture(id); } catch (err) {} });
    }
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'mouse') return hover(e);
    if (!g || !pts.has(e.pointerId)) return;
    var z = g.z, p = local(z, e); pts.set(e.pointerId, p);
    if (z.mode === 'pinch' && pts.size >= 2) {
      var m = two(), P = g.pinch, ns = Math.max(1, Math.min(MAX, P.s0 * m.d / P.d0));
      var qx = (P.mx - z.ox - P.tx0) / P.s0, qy = (P.my - z.oy - P.ty0) / P.s0;
      z.s = ns; z.tx = m.x - z.ox - qx * ns; z.ty = m.y - z.oy - qy * ns;
      clamp(z); if (ns > 1.05) hiRes(z); apply(z, false); return;
    }
    if (pts.size !== 1) return;
    var dx = p.x - g.x0, dy = p.y - g.y0;
    g.moved = Math.max(g.moved, Math.hypot(dx, dy));
    if (z.mode === 'pan' && z.s > 1.01) { z.tx = g.tx0 + dx; z.ty = g.ty0 + dy; clamp(z); apply(z, false); }
  }, true);
  function up(e) {
    if (e.pointerType === 'mouse' || !g || !pts.has(e.pointerId)) return;
    var z = g.z; pts.delete(e.pointerId);
    if (z.mode === 'pinch' && pts.size === 1) {
      var r = Array.from(pts.values())[0];
      g.x0 = r.x; g.y0 = r.y; g.tx0 = z.tx; g.ty0 = z.ty; z.mode = 'pan'; return;
    }
    if (pts.size) return;
    if (g.moved > 10) suppressClickUntil = Date.now() + 400;
    if (z.s < 1.05) reset(z, true); else z.mode = null;
    g = null;
  }
  document.addEventListener('pointerup', up, true);
  document.addEventListener('pointercancel', up, true);

  /* keep the gallery's own swipe-to-change-image from firing while zoomed / pinching */
  function guardTouch(e) {
    var f = frameOf(e.target); if (!f) return;
    var z = Z.get(f);
    if (e.type === 'touchstart' && e.touches.length > 1) multi = true;
    if ((z && z.s > 1.01) || multi || (e.touches && e.touches.length > 1)) e.stopPropagation();
    if (e.type !== 'touchstart' && e.touches.length === 0) setTimeout(function () { multi = false; }, 0);
  }
  document.addEventListener('touchstart', guardTouch, { capture: true, passive: true });
  document.addEventListener('touchend', guardTouch, { capture: true, passive: true });
  document.addEventListener('touchcancel', guardTouch, { capture: true, passive: true });

  /* ---------- tap to zoom / magnifier toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    /* Dawn lightbox opener (fallback if the template still has it): never open the modal for images */
    var tog = t.closest('.product__media-toggle');
    if (tog && tog.closest('[id^="MediaGallery-"]') && !tog.closest('quick-add-modal')) {
      var li = tog.closest('.product__media-item'), fr = li && li.querySelector('.product__media');
      if (fr && frameOf(fr)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!(lastPointer === 'mouse' && fine.matches) && Date.now() >= suppressClickUntil) tapZoom(state(fr), e);
      }
      return;
    }
    var zb = t.closest('.ai-gallery-main [data-zoom]');
    if (zb) {
      e.preventDefault(); e.stopImmediatePropagation();
      var zz = state(zb.closest('.ai-gallery-main')); measure(zz);
      if (zz.s > 1.01) reset(zz, true); else zoomAt(zz, TAP_SCALE, zz.W / 2, zz.H / 2, true);
      return;
    }
    if (t.closest('button, a, input, select, label')) return;
    var f = frameOf(t); if (!f) return;
    if (lastPointer === 'mouse' && fine.matches) return; /* desktop: hover handles zoom; click does nothing */
    if (Date.now() < suppressClickUntil) return;
    tapZoom(state(f), e);
  }, true);
  function tapZoom(z, e) {
    if (!z.img) return;
    if (z.s > 1.01) { reset(z, true); return; }
    var p = local(z, e);
    if (!e.clientX && !e.clientY) { measure(z); p = { x: z.W / 2, y: z.H / 2 }; }
    zoomAt(z, TAP_SCALE, p.x, p.y, true);
  }

  /* ---------- desktop hover magnifier ---------- */
  function hover(e) {
    if (!fine.matches) return;
    var f = frameOf(e.target);
    Array.from(zoomed).forEach(function (z) { if (z.hover && z.frame !== f) reset(z, false); });
    if (!f) return;
    var z = state(f); if (!z.img) return;
    var p = local(z, e);
    if (!z.hover) { z.hover = true; z.s = 1; z.tx = z.ty = 0; measure(z); }
    /* keep the point under the cursor fixed => image follows the cursor */
    z.s = HOVER_SCALE; z.tx = (p.x - z.ox) * (1 - z.s); z.ty = (p.y - z.oy) * (1 - z.s);
    clamp(z); hiRes(z); apply(z, false);
  }
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var f = frameOf(e.target); if (!f) return;
    if (e.relatedTarget && f.contains(e.relatedTarget)) return;
    var z = Z.get(f); if (z && z.hover) reset(z, false);
  }, true);

  /* ---------- reset when the image or colour changes ---------- */
  new MutationObserver(function (list) {
    for (var k = 0; k < list.length; k++) {
      var n = list[k].target;
      if (n.classList && n.classList.contains('hgz-img')) {
        var f = n.closest('.hgz-frame'), z = f && Z.get(f);
        if (z && z.s > 1.01 && !z.hover) { lowRes(n); reset(z, false); }
        else if (z && !z.hover) lowRes(n);
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  document.addEventListener('change', function () { resetAll(); }, true); /* any option / colour change */
  document.addEventListener('scroll', function (e) { if (e.target !== document && e.target.closest && e.target.closest('[id^="MediaGallery-"]')) resetAll(); }, true);
  window.addEventListener('resize', function () { if (!g) resetAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') resetAll(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);

  window.HGZoom = {
    state: function (sel) { var f = document.querySelector(sel || FRAME_SEL); var z = f && Z.get(f); return z ? { s: z.s, tx: z.tx, ty: z.ty, mode: z.mode } : null; },
    reset: resetAll
  };
})();
